import { productById } from '../data/products';
import { predictOocytes } from './responseModel';
import type { PatientPreset } from '../types/simulation';
import type { Treatment } from '../types/treatment';

/**
 * ILLUSTRATIVE ONLY — this is NOT a dose conversion between products.
 * IU-labelled FSH doses are mapped onto the response model's internal stimulus
 * scale so that every choice can be placed on the same illustrative continuum.
 */
const MODEL_IU_PER_UNIT = 18.75;

export function modelStimulus(t: Treatment): number {
  return t.unit === 'μg' ? t.dose : t.dose / MODEL_IU_PER_UNIT;
}

export function modelPosition(patient: PatientPreset, t: Treatment): number {
  return predictOocytes(patient.amh, modelStimulus(t), patient.weight);
}

export function formatDose(dose: number, unit: Treatment['unit']): string {
  const v = unit === 'μg' ? dose.toFixed(2) : Number.isInteger(dose) ? String(dose) : dose.toFixed(1);
  return `${v} ${unit}`;
}

export function formatTreatment(t: Treatment): string {
  return `${productById(t.product).name} ${formatDose(t.dose, t.unit)}`;
}

export function sameTreatment(a: Treatment, b: Treatment): boolean {
  return a.product === b.product && a.dose === b.dose && a.unit === b.unit;
}
